/**
 * View-Only User Screen
 *
 * Displayed when a viewer/view-only user tries to access TaskLoops.
 * Viewers cannot use the monday.com API, so all operations would fail.
 * Blocks at the dashboard layout level to prevent confusing error states.
 */

export function ViewOnlyScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--surface-bg)]">
      <div className="text-center p-8 max-w-md">
        <div className="mb-6">
          <div className="w-16 h-16 mx-auto bg-amber-100 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
        </div>

        <h1 className="text-2xl font-bold text-[var(--text-heading)] mb-4">
          Viewer Access Not Supported
        </h1>

        <p className="text-[var(--text-secondary)] mb-6">
          TaskLoops requires permissions to read and update your monday.com boards.
          Viewer accounts don&apos;t have these permissions.
        </p>

        <p className="text-sm text-[var(--text-secondary)]">
          Please ask your account admin to upgrade your role to Member.
        </p>
      </div>
    </div>
  );
}
